module.exports = __webpack_public_path__ + "static/media/43-4.861815e4.mp3";